import React, { useState } from "react";
import { Form, Input, Button, Radio, Card } from "antd";
import { Link } from "react-router-dom";
import Logo from "../../Images/logo.png";

const ResetPassword = () => {
  const [form] = Form.useForm();
  const [selection, setSelection] = useState("reset_password");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const onRadioChange = (e) => {
    setSelection(e.target.value);
    form.resetFields(["user_name", "user_email"]);
    setIsButtonDisabled(true);
  };

  const handleValuesChange = (_, allValues) => {
    console.log("allValues", allValues);
    const { user_name = "", user_email = "" } = allValues;

    const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    if (
      (selection === "reset_password" && user_name.length >= 6) ||
      (selection === "reset_username" && emailPattern.test(user_email))
    ) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  };

  const onFinish = (values) => {
    if (selection === "reset_password") {
      console.log("Reset Password for:", values.username_email);
    } else {
      console.log("Reset Username for:", values.username_email);
    }
  };

  return (
    <div className="wi-log-outer">
      <div className="container">
        <div className="row w-log-bg">
          <div className="col-xl-6 col-sm-12 py-3">
            <Card
              style={{
                padding: 20,
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: 10,
                textAlign: "center",
              }}
            >
              <img src={Logo} style={{ width: "40%" }}></img>
              <h4 style={{ textAlign: "center" }}>Reset Password/Username</h4>
              <Form
                form={form}
                onFinish={onFinish}
                layout="vertical"
                onValuesChange={handleValuesChange}
              >
                <Form.Item>
                  <Radio.Group
                    onChange={onRadioChange}
                    value={selection}
                    style={{
                      display: "block",
                      textAlign: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <Radio value="reset_password">Reset Password</Radio>
                    <Radio value="reset_username">Reset Username</Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item
                  name={
                    selection === "reset_password" ? "user_name" : "user_email"
                  }
                  label={
                    selection === "reset_password"
                      ? "Username"
                      : "Email Address"
                  }
                  rules={[
                    {
                      required: true,
                      message: `Please input your ${
                        selection === "reset_password"
                          ? "Username"
                          : "Email Address"
                      }!`,
                    },
                    ...(selection === "reset_username"
                      ? [
                          {
                            pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
                            message: "Please enter a valid email address!",
                          },
                        ]
                      : []),
                  ]}
                >
                  <Input
                    placeholder={`Enter ${
                      selection === "reset_password"
                        ? "Username"
                        : "Email Address"
                    }`}
                  />
                </Form.Item>

                <Form.Item style={{ textAlign: "center" }}>
                  <Button
                    disabled={isButtonDisabled}
                    type="primary"
                    htmlType="submit"
                    size="large"
                  >
                    Reset
                  </Button>
                </Form.Item>
                <Form.Item>
                  <div className="row justify-content-center">
                    <div className="col">
                      <Link to="/">Back to login</Link>
                    </div>
                  </div>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
